<template>
  <div class="experience_home">
    <!-- 教育经历 -->
    <div class="box">
      <div class="experience_education">
        <div class="left">
          <span class="name">教育经历</span>
          <el-popover
            placement="right-end"
            title="加分说明"
            width="500"
            trigger="hover"
          >
            <ul>
              <li>1.xxxxxxxxxxxxxxxxxxxxxxxxxxxx</li>
              <li>2.xxxxxxxxxxxxxxxxxxxxxxxxxxxx</li>
              <li>3.xxxxxxxxxxxxxxxxxxxxxxxxxxxx</li>
            </ul>
            <template slot="reference">
              <span class="desc">
                <i class="el-icon-question"></i>加分说明
              </span>
            </template>
          </el-popover>
        </div>
        <div class="right" @click="go('personal_center_add_education')">
          <span>
            <i class="el-icon-circle-plus-outline"></i>
          </span>
          <span>添加</span>
        </div>
      </div>
      <ul class="list" v-if="edu.length">
        <edu_item v-for="item in edu" :key="item.id" :item="item" />
      </ul>
    </div>
    <!-- 获奖经历 -->
    <div class="box">
      <div class="experience_education">
        <div class="left">
          <span class="name">获奖经历</span>
          <el-popover
            placement="right-end"
            title="加分说明"
            width="500"
            trigger="hover"
          >
            <ul>
              <li>1.xxxxxxxxxxxxxxxxxxxxxxxxxxxx</li>
              <li>2.xxxxxxxxxxxxxxxxxxxxxxxxxxxx</li>
              <li>3.xxxxxxxxxxxxxxxxxxxxxxxxxxxx</li>
            </ul>
            <template slot="reference">
              <span class="desc">
                <i class="el-icon-question"></i>加分说明
              </span>
            </template>
          </el-popover>
        </div>
        <div class="right" @click="go('personal_center_add_praise')">
          <span>
            <i class="el-icon-circle-plus-outline"></i>
          </span>
          <span>添加</span>
        </div>
      </div>
      <ul class="list2" v-if="prize.length">
        <prize_item v-for="item in prize" :key="item.id" :item="item" />
      </ul>
    </div>
  </div>
</template>

<script>
import edu_item from "@/components/list_item/edu_item.vue";
import prize_item from "@/components/list_item/prize_item.vue";
export default {
  components: {
    edu_item,
    prize_item
  },
  data() {
    return {
      edu: [], //教育经历
      prize: [] //获奖经历
    };
  },
  created() {
    this.getFrontExtends("ExtendTypePrize"); //获奖经历
    this.getFrontExtends("ExtendTypeEducation"); //教育经历
  },
  methods: {
    getFrontExtends(type) {
      let params = {
        // status:"IdentityCertifieStatussuccess",//认证通过
        type: type //经历
      };
      this.api.getFrontExtends(params).then(res => {
        if (res.error.err_code !== 0) return;
        let list = res.obj.list || [];
        if (type === "ExtendTypePrize") {
          this.prize = list; //获奖经历
        } else {
          this.edu = list; //教育经历
        }
      });
    },
    go(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.experience_home {
  .box {
    margin-bottom: 10px;
  }
  .experience_education {
    height: 76px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    padding: 30px;
    box-sizing: border-box;
    .left {
      .name {
        font-size: 16px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        margin-right: 20px;
      }
      .desc {
        font-size: 14px;
        color: rgba(153, 153, 153, 1);
        cursor: pointer;
      }
    }
    .right {
      span {
        font-size: 14px;
        color: rgba(17, 126, 255, 1);
        cursor: pointer;
        i {
          margin-right: 5px;
        }
      }
    }
  }

  .list {
    padding: 0 28px 10px 30px;
    background: #fff;
  }
  .list2 {
    background: #fff;
    padding: 0 28px 30px 30px;
  }
}
</style>